import { apiRequest } from "../lib/apiClient";
import type { TenantEcommerceSettingsOut, TenantEcommerceSettingsUpdate } from "./types";

/** `GET /tenant-settings/ecommerce` — any authenticated user. */
export async function getEcommerceSettings(accessToken: string): Promise<TenantEcommerceSettingsOut> {
  return apiRequest<TenantEcommerceSettingsOut>("/tenant-settings/ecommerce", { accessToken });
}

/** `PATCH /tenant-settings/ecommerce` — OWNER only. */
export async function updateEcommerceSettings(
  accessToken: string,
  body: TenantEcommerceSettingsUpdate,
): Promise<TenantEcommerceSettingsOut> {
  return apiRequest<TenantEcommerceSettingsOut>("/tenant-settings/ecommerce", { method: "PATCH", accessToken, body });
}
